import { useEffect, useCallback } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  const scrollToHash = useCallback((targetHash: string) => {
    let attempts = 0;
    const maxAttempts = 50;
    const tryScroll = () => {
      const el = document.querySelector(targetHash);
      if (el) {
        el.scrollIntoView({ behavior: "instant" });
      } else if (attempts < maxAttempts) {
        attempts++;
        requestAnimationFrame(tryScroll);
      }
    };
    requestAnimationFrame(tryScroll);
  }, []);

  useEffect(() => {
    if (navType === "POP") return;
    if (hash) {
      scrollToHash(hash);
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, hash, navType, scrollToHash]);

  // Fallback: listen for hashchange events that React Router may not capture
  useEffect(() => {
    const handleHashChange = () => {
      const newHash = window.location.hash;
      if (newHash) {
        scrollToHash(newHash);
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [scrollToHash]);

  return null;
};
